import classNames from 'classnames';
import * as React from 'react';

import styles from './HiddenField.module.css';

type HiddenFieldProps = Omit<React.HTMLProps<HTMLInputElement>, 'type'>;

const HiddenField = ({ className, ...inputProps }: HiddenFieldProps) => (
    <input
        {...inputProps}
        type="hidden"
        className={classNames(className, styles.Root)}
    />
);

export default HiddenField;
